import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { getNewsByFilter } from "../api/apiHandler";
import { getMediaBaseUrl } from "../utils/backendUrl";

const Footer = () => {
  const [latestStories, setLatestStories] = useState([]);

  const BASE_URL = getMediaBaseUrl();

  useEffect(() => {
    let isMounted = true;
    const loadLatest = async () => {
      try {
        const res = await getNewsByFilter({ limit: 4 });
        const items = Array.isArray(res?.data) ? res.data : [];
        if (isMounted) {
          setLatestStories(
            items.map((item) => {
              let imageUrl = "";
              if (item.thumbnail) {
                if (item.thumbnail.startsWith("http")) {
                  imageUrl = item.thumbnail;
                } else if (item.thumbnail.startsWith("/images/")) {
                  imageUrl = item.thumbnail;
                } else {
                  imageUrl = `${BASE_URL}/uploads/news/${encodeURIComponent(item.thumbnail)}`;
                }
              }
              return {
                id: item.id,
                title: item.news_title || item.title || "",
                image: imageUrl,
              };
            })
          );
        }
      } catch (err) {
        console.error("Error fetching latest stories:", err);
      }
    };
    loadLatest();
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <footer className="relative bg-[#2d006b] text-purple-100 pt-16 overflow-hidden border-t border-brand-red">
      {/* Decorative gradient blob */}
      

      <div className="relative max-w-7xl mx-auto px-4 z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 pb-12">
          
          {/* LOGO & ABOUT */}
          <div className="lg:col-span-4 flex flex-col items-start pr-4">
            <h3 className="text-2xl font-bold text-white mb-4 tracking-wide">
              मंदाकिनी<span className="text-brand-red"> टाइम्स</span>
            </h3>
            <p className="text-sm text-purple-200 mb-6 leading-relaxed">
              मध्य प्रदेश, छत्तीसगढ़ और दुनिया भर से नवीनतम समाचार, ब्रेकिंग न्यूज़ और गहन विश्लेषण।
            </p>

            {/* CONTACT INFO */}
            <div className="mb-6 space-y-3">
              <div className="flex items-start gap-3">
                <i className="fas fa-map-marker-alt text-brand-red mt-1"></i>
                <p className="text-sm text-purple-200">
                  प्रधान कार्यालय: मंदाकिनी टाइम्स, छतरपुर, मध्य प्रदेश, भारत
                </p>
              </div>
              <div className="flex items-center gap-3">
                <i className="fas fa-envelope text-brand-red"></i>
                <a href="mailto:info@mandakinitimes.com" className="text-sm text-purple-200 hover:text-brand-red transition-colors">
                  info@mandakinitimes.com
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="fas fa-phone-alt text-brand-red"></i>
                <a href="tel:+919755724915" className="text-sm text-purple-200 hover:text-brand-red transition-colors">
                  +91 97557 24915
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="fab fa-whatsapp text-brand-red text-lg"></i>
                <a href="https://wa.me/919755724915" target="_blank" rel="noopener noreferrer" className="text-sm text-purple-200 hover:text-brand-red transition-colors">
                  +91 97557 24915
                </a>
              </div>
            </div>

            {/* SOCIAL ICONS */}
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-[#1877F2] text-white flex items-center justify-center hover:opacity-80 transition-all duration-300 shadow-lg hover:-translate-y-1">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gradient-to-tr from-[#f09433] via-[#dc2743] to-[#bc1888] text-white flex items-center justify-center hover:opacity-80 transition-all duration-300 shadow-lg hover:-translate-y-1">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-brand-red border border-purple-500 text-white flex items-center justify-center hover:opacity-80 transition-all duration-300 shadow-lg hover:-translate-y-1">
                <i className="fab fa-x-twitter"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-[#FF0000] text-white flex items-center justify-center hover:opacity-80 transition-all duration-300 shadow-lg hover:-translate-y-1">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>

          {/* CATEGORIES */}
          <div className="lg:col-span-2">
            <h4 className="text-white font-semibold mb-6 uppercase text-sm tracking-widest border-b-2 border-brand-red inline-block pb-1">
              श्रेणियाँ
            </h4>
            <ul className="space-y-3 text-sm grid grid-cols-1 gap-1">
              {[
                { name: "राष्ट्रीय", path: "/category/national" },
                { name: "विश्व", path: "/category/international" },
                { name: "राजनीति", path: "/category/politics" },
                { name: "व्यापार", path: "/category/business" },
                { name: "मनोरंजन", path: "/category/entertainment" },
                { name: "खेल", path: "/category/sports" },
                { name: "टेक/विज्ञान", path: "/category/technology" },
                { name: "धर्म/ज्योतिष", path: "/category/religion" },
                { name: "स्वास्थ्य/जीवन शैली", path: "/category/health" }
              ].map((cat, idx) => (
                <li key={idx}>
                  <NavLink to={cat.path} className="group flex items-center text-purple-200 hover:text-brand-red transition-colors duration-300">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-red mr-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                    {cat.name}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* USEFUL LINKS */}
          <div className="lg:col-span-2">
            <h4 className="text-white font-semibold mb-6 uppercase text-sm tracking-widest border-b-2 border-brand-red inline-block pb-1">
              उपयोगी लिंक
            </h4>
            <ul className="space-y-3 text-sm">
              {[
                { name: "हमारे बारे में", path: "/about" },
                { name: "हमारी टीम", path: "/team" },
                { name: "ब्लॉग", path: "/blog" },
                { name: "फोटो गैलरी", path: "/gallery/photos" },
                { name: "वीडियो गैलरी", path: "/gallery/videos" },
                { name: "गोपनीयता नीति", path: "/privacy" },
                { name: "नियम एवं शर्तें", path: "/terms" },
                { name: "संपर्क करें", path: "/contact" }
              ].map((link, idx) => (
                <li key={idx}>
                  <NavLink to={link.path} className="group flex items-center text-purple-200 hover:text-white transition-colors duration-300">
                    <span className="w-1.5 h-1.5 rounded-full bg-white mr-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                    {link.name}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* LATEST STORIES */}
          <div className="lg:col-span-4">
            <h4 className="text-white font-semibold mb-6 uppercase text-sm tracking-widest border-b-2 border-brand-red inline-block pb-1">
              नवीनतम कहानियाँ
            </h4>
            <ul className="space-y-4">
              {latestStories && latestStories.length > 0 ? (
                latestStories.slice(0, 4).map((news, idx) => (
                  <li key={idx} className="group flex items-start gap-4 cursor-pointer">
                    <div className="w-16 h-16 rounded overflow-hidden flex-shrink-0 bg-brand-red border border-purple-500">
                      {news.image ? (
                        <img 
                          src={news.image} 
                          alt={news.title} 
                          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                        />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center text-gray-600">
                          <i className="fas fa-image"></i>
                        </div>
                      )}
                    </div>
                    <Link to={`/news/${news.id || 1}`} className="text-sm font-medium text-purple-100 group-hover:text-brand-red transition-colors duration-300 line-clamp-3 leading-snug">
                      {news.title}
                    </Link>
                  </li>
                ))
              ) : (
                <li className="text-sm text-purple-300 italic">कोई नवीनतम कहानियाँ उपलब्ध नहीं हैं।</li>
              )}
            </ul>
          </div>

        </div>

        {/* COPYRIGHT */}
        <div className="border-t border-brand-red pt-6 pb-20 md:py-6 flex flex-col md:flex-row items-center justify-between text-sm text-purple-300">
          <p>© 2026 मंदाकिनी टाइम्स। सर्वाधिकार सुरक्षित।</p>
          <div className="mt-3 md:mt-0 flex items-center gap-1 bg-[#1a0040] px-4 py-1.5 rounded-full border border-brand-red">
            <span>द्वारा डिज़ाइन और विकसित:</span>
            <a href="https://yashsoftsolution.com" target="_blank" rel="noopener noreferrer" className="font-semibold text-brand-red hover:text-white transition-colors duration-300 ml-1">
              Yashsoft Solution
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
